import { render, staticRenderFns } from "./newsxiangqing2.vue?vue&type=template&id=52be58f3&scoped=true&"
import script from "./newsxiangqing2.vue?vue&type=script&lang=js&"
export * from "./newsxiangqing2.vue?vue&type=script&lang=js&"
import style0 from "./newsxiangqing2.vue?vue&type=style&index=0&id=52be58f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be58f3",
  null
  
)

export default component.exports